<template>
  <td class="table-roster-cell">
    <template v-if="rosterEnabled && count">
      <ux-menu right group="roster-preview">
        <template #activator="{ on }">
          <ux-button size="sm" v-on="on" icon @click.stop>
            {{ count }}
          </ux-button>
        </template>
        <ux-panel>
          <ux-panel-header>
            <div class="event-title">{{ row.title }}</div>
            <div class="event-date">{{ $sdk.date.readableEventDate(row) }}</div>
            <div class="event-subtitle">{{ row.subtitle }}</div>
          </ux-panel-header>
          <ux-panel-body>
            <div class="preview">
              <div v-for="roster in rosters">
                <!-- <h5>{{ roster.title }}</h5> -->
                <div class="grid">
                  <div v-for="slot in roster.slots">
                    <h4>{{ slot.title }}</h4>

                    <div
                      class="assignment"
                      :class="assignment.state || 'unknown'"
                      v-for="assignment in slot.assignments"
                    >
                      <flex-row gap center>
                        <flex-cell shrink>
                          <div class="face">
                            <ux-avatar
                              :initials="`${assignment.profile.firstName} ${assignment.profile.lastName}`"
                              :id="assignment.profile"
                            />
                          </div>
                        </flex-cell>
                        <flex-cell>
                          {{ assignment.profile?.firstName }}&nbsp;{{
                            assignment.profile?.lastName
                          }}
                        </flex-cell>
                      </flex-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ux-panel-body>
        </ux-panel>
      </ux-menu>
    </template>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  computed: {
    count() {
      return this.rosters.reduce(function (memo, roster) {
        roster.slots.forEach(function (slot) {
          memo += slot.assignments.length;
        });

        return memo;
      }, 0);
    },
    rosters() {
      const rosterEntries = Object.entries(this.row.join_roster || {}).map(
        function ([key, roster]) {
          return {
            title: key,
            slots: roster.items,
          };
        },
      );

      return rosterEntries;
    },
    rosterEnabled() {
      const hasFeature = this.$sdk.access.hasFeature(this.user, "rostering");

      if (!hasFeature) {
        return;
      }

      const hasAccess =
        this.$sdk.access.canKnowOf(this.user, "roster") ||
        this.$sdk.access.canKnowOf(this.user, "assignment");
      return hasAccess;
    },
  },
};
</script>
<style scoped lang="scss">
td {
}

.event-title {
  font-weight: 500;
}
.event-date {
}
.event-subtitle {
  font-size: 0.9em;
  opacity: 0.7;
}

.face {
  display: block;
  width: 2em;
  height: 2em;
}

.preview {
  font-size: 0.9em;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(150px, 1fr));
}

.assignment {
  margin-bottom: 2px;
  display: block;

  &.declined {
    color: red;
  }

  &.confirmed {
    color: green;
  }

  &.unknown {
    /* opacity: 0.8; */
  }

  &.proposed {
    color: var(--primary);
    opacity: 0.5;
  }
}
</style>
